<template>
  <div
    am-param-modal-item
    v-click-outside="() => isEdit = false"
  >
    <div class="_display:flex _flex-wrap:wrap _align-items:center">
      <i-badge
        v-for="(value, key) in data.data"
        :key="key"
        am-param-badge
        color="info"
        class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
      >
        <p class="_margin:0">
          {{ Number(key) ?  `par ${key}` : `${key}`}} = {{ value.join() }}
        </p>
        <div class="_margin-left:1/2">
          <svg
            viewBox="0 0 24 24"
            am-icon
            class="_margin-right:1/4"
            style="fill: var(--color--secondary-10);"
            @click="editParam(key)"
          >
            <use xlink:href="@/assets/icons.svg#edit" x="0" y="0" width="24" height="24"></use>
          </svg>
          <svg
            viewBox="0 0 24 24"
            am-icon
            style="fill: var(--color--secondary-10);"
            @click="delPar(key)"
          >
            <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
      </i-badge>
      <svg viewBox="0 0 24 24" am-icon class="_margin:1/4" @click="addParam()">
        <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
      </svg>
    </div>
    <template v-if="isEdit">
      <hr>
      <div am-edit-param class="_display:inline-flex _align-items:center _width:100%!">
        <i-dropdown class="_margin-right:1/2" :disabled="isEdit === 'edit'">
          <p>{{ dropChecked }}</p>
          <template #body>
            <i-dropdown-item
              v-for="dropValue in dropValues"
              :key="dropValue"
              :disabled="dropValue === dropChecked"
              @click.prevent="inputCheck(dropValue)"
            >
              {{ dropValue }}
            </i-dropdown-item>
          </template>
        </i-dropdown>
        <i-input
          v-if="dropChecked === 'par'"
          v-model="inputNumber"
          :error="numberEror"
          :disabled="isEdit === 'edit'"
          am-number-input
          type="number"
          placeholder="Number"
        />
        <p class="_margin-left:1/4 _margin-right:1/4">=</p>
        <ITextarea
          am-params-textarea
          :style="`height:${heightArea}px;`"
          v-model="inputValue"
          @keypress="watchValue"
          placeholder="Value"
        />
      </div>
      <p class="_color:danger">{{ errorMessage }}</p>
      <div class="_margin-top:1/2" am-buttons>
        <i-button class="_width:50% _margin-right:1/2" @click="add()" :disabled="numberEror">
          {{ isEdit === 'add' ? 'Add' : 'Save' }}
        </i-button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'ParamsItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isActive: false,
    isEdit: false,
    number: null,
    numberEror: false,
    value: null,
    dropValues: ['par', 'завтал', 'waistband', 'ruffle', 'cuff', 'facing', 'lining', 'elastik', 'loop'],
    dropChecked: 'par',
    errorMessage: '',
    heightArea: null
  }),
  computed: {
    val () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data
    },
    inputValue: {
      get () {
        if (this.value instanceof Array) return this.value.join()
        return this.value
      },
      set (val) {
        if (val.includes(',')) {
          this.value = val.split(',').map(el => {
            if (!el.trim()) return el
            return Number(el.trim())
          })
        } else {
          this.value = [Number(val)]
        }
      }
    },
    inputNumber: {
      get () {
        return this.number
      },
      set (num) {
        this.number = num
        if (this.val[num] || this.val[num] === 0) {
          this.numberEror = true
          this.errorMessage = 'this params already exists'
        } else {
          this.numberEror = false
          this.errorMessage = ''
        }
      }
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    watchValue (event) {
      const regex = /^[0-9 ,]+$/
      const key = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(key)) {
        event.preventDefault()
        return false
      }
    },
    delPar (key) {
      delete this.val[key]
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    },
    add () {
      if (this.value !== null && Array.isArray(this.value) && !this.value[this.value.length - 1]) {
        this.value.splice(this.value.length - 1, 1)
      }
      if (this.dropChecked !== 'par' && this.value !== null) {
        this.val[this.dropChecked] = this.value
        this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
        this.isEdit = false
      } else if (this.value !== null && this.number !== null) {
        this.val[this.number] = this.value
        this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
        this.isEdit = false
      } else {
        this.errorMessage = 'all fields are required'
      }
    },
    reset () {
      this.number = null
      this.value = null
      this.dropChecked = 'par'
      this.numberEror = false
      this.errorMessage = ''
    },
    inputCheck (dropValue) {
      if (dropValue !== 'par') this.number = null
      this.dropChecked = dropValue
    },
    addParam () {
      this.reset()
      this.isEdit = 'add'
    },
    editParam (key) {
      this.reset()
      if (Number(key)) {
        this.number = key
        this.dropChecked = 'par'
      } else {
        this.dropChecked = key
        this.number = null
      }
      this.value = this.val[key]
      this.isEdit = 'edit'
      setTimeout(() => {
        this.inputHeight()
      }, 0)
    },
    inputHeight () {
      const textarea = document.querySelector('[am-params-textarea]')
      if (textarea.scrollHeight > textarea.clientHeight) {
        this.heightArea = textarea.scrollHeight
      }
    }
  },
  mounted () {
    if (Array.isArray(this.data.data)) {
      this.val = {}
    }
  }
}
</script>

<style lang="scss">
[am-param-modal-item] {
  [am-number-input] {
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button {
      display: none;
    }
  }
  [am-buttons] {
    button {
      max-width: 14.5rem;
    }
    button:hover {
      ----border-color: var(--color--dark);
    }
  }
  [am-edit-param] {
    width: 100%;
    .input-wrapper {
      width: 100%;
    }
  }
}
</style>
